import { matchPath } from "react-router-dom";
import { RouteDrawerMatch } from "./routeDrawers";

/** Detail URLs stay shareable; their parent list supplies the background. */
export const ROUTE_DETAILS = [
  { parent: "/purchase-orders", title: "Purchase order details", width: 1240 },
  { parent: "/warranty", title: "Warranty details", width: 1000 },
  { parent: "/inspections/history", title: "Inspection details", width: 1120 },
  { parent: "/inspections/forms", title: "Inspection form details", width: 1120 },
  { parent: "/parts", title: "Part details", width: 1120 },
  { parent: "/units", title: "Vehicle details", width: 1240 },
  { parent: "/settings/users", title: "User details", width: 1120 },
  { parent: "/equipments", title: "Equipment details", width: 1240 },
];

const RESERVED_IDS = new Set(["add", "create", "edit", "update", "import", "export"]);

export const findRouteDetail = (pathname: string, search = ""): RouteDrawerMatch | null => {
  for (const config of ROUTE_DETAILS) {
    const detailPath = `${config.parent}/:id`;
    const match = matchPath({ path: detailPath, end: true }, pathname);
    if (!match?.params.id || RESERVED_IDS.has(match.params.id)) continue;
    return {
      config: { ...config, create: detailPath },
      parentPath: config.parent,
      formPath: pathname,
      formSearch: search,
    };
  }
  return null;
};
